import { Menu } from 'antd';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { currentToken, currentUser } from '../../../features/user/userSlice';
import {
  MyReportsIcon,
  MyTeamIcon,
  MyInfoIcon,
  SetAvatarIcon,
  SetPasswordIcon,
  TwoFAIcon,
  Creport,
  Cinfo,
  Clogo,
  Cpassword, PolicyIcon, MfAdministratorIcon,
} from '../../../icons';
import { useTranslation } from 'react-i18next';

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

const SidebarMenu = ({ menuItemClick, fromAddteam, toWallet, defaultPage = '' }) => {
  const { t } = useTranslation();
  const [openKeys, setOpenKeys] = useState([defaultPage]);
  const user = useSelector(currentUser);
  const token = useSelector(currentToken);
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKeys, setSelectedKeys] = useState(
      defaultPage ? defaultPage : (
          fromAddteam && fromAddteam
              ? 'my_team'
              // : user && user?.user?.type === 0
              //     ? 'my_report'
              //     : 'mf_report'
              : 'my_report'
      )
  );

  useLayoutEffect(() => {
    if (toWallet) {
      if (location.state.wallet_address) {
        handleClick({key : 'my_info'});
      }
    }
  }, []);

  const items = [
    getItem(
      t('user_center.my_report'),
      'my_report',
      <MyReportsIcon selectedKeys={selectedKeys} />
    ),
    getItem(
        'My Team',
        'team',
        <MyTeamIcon selectedKeys={selectedKeys} />
    ),
    getItem(
        t('user_center.personal profile'),
        'my_info',
        <MyInfoIcon selectedKeys={selectedKeys} />
    ),
    // getItem(
    //   t('user_center.my_team'),
    //   'my_team',
    //   <MyTeamIcon selectedKeys={selectedKeys} />
    // ),
    // getItem(
    //   t('user_center.Set avatar'),
    //   'set_avater',
    //   <SetAvatarIcon selectedKeys={selectedKeys} />
    // ),
    getItem(
      t('user_center.Change password'),
      'set_passeord',
      <SetPasswordIcon selectedKeys={selectedKeys} />
    ),
    getItem(
      t('user_center.2fa.menu'),
      '2fa',
      <TwoFAIcon selectedKeys={selectedKeys} />
    ),
    // getItem('Navigation Two', 'sub2', <AppstoreOutlined />, [
    //   getItem('Option 5', '5'),
    //   getItem('Option 6', '6'),
    //   getItem('Submenu', 'sub3', null, [
    //     getItem('Option 7', '7'),
    //     getItem('Option 8', '8'),
    //   ]),
    // ]),
  ]; // submenu keys of first level

  const root_items = [
    getItem(
        t('user_center.Reports'),
        'my_report',
        <Creport selectedKeys={selectedKeys} />
    ),
    getItem(
        t('user_center.Administrator'),
        'mf_administrator',
        <MfAdministratorIcon selectedKeys={selectedKeys} />
    ),
    getItem(
        t('user_center.Project Details'),
        'mf_info',
        <Cinfo selectedKeys={selectedKeys} />
    ),
    // getItem(
    //   t('user_center.Set the logo'),
    //   'mf_set_logo',
    //   <Clogo selectedKeys={selectedKeys} />
    // ),
    getItem(
        t('user_center.Policy'),
        'policy',
        <PolicyIcon selectedKeys={selectedKeys} />
    ),
    getItem(
      t('user_center.Change password'),
      'mf_set_passeord',
      <Cpassword selectedKeys={selectedKeys} />
    ),
    getItem(
      t('user_center.2fa.menu'),
      '2fa',
      <TwoFAIcon selectedKeys={selectedKeys} />
    ),
  ];

  const rootSubmenuKeys = [
    'my_report',
    'my_team',
    'my_info',
    'set_avater',
    'set_passeord',
    '2fa',
  ];

  const ManufacturerSidebarMenuKeys = [
    'mf_report',
    'mf_info',
    'team',
    'mf_set_logo',
    'mf_set_passeord',
    '2fa',
  ];

  useEffect(() => {
    if (!token) {
      navigate('/', { replace: true });
    }
  }, []);
  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);

    const Keys =
      user && user.user.type === 1
        ? ManufacturerSidebarMenuKeys
        : rootSubmenuKeys;

    if (Keys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const handleClick = (e) => {
    setSelectedKeys(e.key);
    menuItemClick(e);
  };

  return (
    <Menu
      mode="inline"
      openKeys={openKeys}
      // defaultSelectedKeys={defaultPage ? [defaultPage] : [
      //   user && user?.user?.type === 0 ? 'my_report' : 'mf_report',
      // ]}
      defaultSelectedKeys={defaultPage ? [defaultPage] : ['my_info']}
      onClick={handleClick}
      onOpenChange={onOpenChange}
      style={{
        minHeight: 'calc(100vh - 161px)',
      }}
      items={user && user.user && user.user.type === 1 ? root_items : items}
    />
  );
};

export default SidebarMenu;
